import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: 'UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計',
  title1: 'UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計',
  company: '株式会社セゾンテクノロジー',
  introduction_text: (
    <>
      セゾンテクノロジー様のプロダクト「HULFT」のUI/UX改善を支援しました。これは、国内シェアNo.1<sup>※</sup>
      プロダクトであるHULFTの、ユーザー層の世代交代に備えた令和版モダナイゼーションを実現するプロジェクトです。
      弊社は、現状のUIのユーザビリティ評価、プロトタイプの作成、潜在的顧客層を想定したユーザーインタビューによるフィードバック収集まで、伴走支援を行いました。
    </>
  ),
  tag1text: 'UX/UI改善',
  tag1src: '/cases/uxui-improvement/',
  tag2text: 'プロトタイピング・仮説検証',
  tag2src: '/cases/prototyping/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  image: '/images/img/cases/hulft/mv.webp',
  movie: '',
  alt: 'UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計',
}

// プロジェクト概要
export const overviewTitle = (
  <>
    国内シェアNo.1<sup>※</sup>プロダクト、令和版モダナイゼーションの第一歩を伴走支援
  </>
)

export const overviewItem: OverviewItems[] = [
  {
    text: '業界内で高いシェアを誇る製品であっても、時代の変化やユーザー層の世代交代に適応し続けることは容易ではありません。特に、長年の歴史がある製品においては、「今のままで本当に良いのか？」という危機感がつきまといます。',
  },
  {
    text: (
      <>
        <a href="https://www.saison-technology.com" target="_blank" rel="noopener">
          株式会社セゾンテクノロジー
        </a>
        の「HULFT（ハルフト）」も、まさにそのような課題に直面していました。国内シェアNo.1<sup>※</sup>
        という実績を持ちながらも、導入企業のユーザーにおける世代交代に対応するため同社は、UI/UXの抜本的な見直しを検討されていました。
      </>
    ),
  },
  {
    text: 'アイスリーデザインは、「HULFT」の今後に向けたプロダクトの方針検討において、ユーザー調査からUIデザイン、プロトタイプの作成までをサポートし、プロダクトの方向性を明確にする支援を行いました。',
  },
  {
    text: '今回は、プロジェクトを推進したセゾンテクノロジー HULFT開発部 部長の宇佐美さん、UI/UXディレクター真田さん、UIデザイナー鹿山さんに加え、アイスリーデザインからはプロジェクトリーダーの武本、UIデザイナーの後藤の5名に、プロジェクトの舞台裏を伺いました。',
  },
  {
    source: (
      <>
        ※出典：株式会社富士キメラ総研「2004-2010パッケージソリューションマーケティング便覧」​
        <br />
        「ソフトウェアビジネス新市場 2011-2024年版」 ＜ファイル転送ツール
        パッケージ・金額ベース＞2003年度実績～2023年度実績（2022年度までセゾン情報システムズ実績）
      </>
    ),
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'ユーザーの声を把握する必要性',
        text: 'HULFTをさらに発展させるためには、ユーザーの声をキャッチアップすることが重要だと感じていた。',
      },
      {
        title: '専門的なノウハウ不足による対応の限界',
        text: '小さくプロジェクトをスタートしたかったが、自部門にはUXリサーチの専門家が不在で、調査や改善に限界があった。',
      },
      {
        title: '内製による発想の限界',
        text: '社内対応では発想が固定化し改良の範囲が限定されがちで自由な意見が出にくいのではという懸念もあった。',
      },
    ],
    solutions: [
      {
        title: 'エキスパートレビューによる課題の洗い出し',
        text: 'ヒューリスティクス10原則やUX5段階モデルに基づいてUI/UXを評価。改善点を洗い出し、社内理解を促進するため丁寧な言語化を行ったレポートを作成した。',
      },
      {
        title: '若い世代のインサイト収集',
        text: '将来のユーザー層に近いセゾンテクノロジーの新卒社員を対象に、NPSアンケートとインタビューを実施。「若い世代のリアルな声」を収集し、提案に説得力を持たせた。',
      },
      {
        title: 'プロトタイプ作成とユーザー評価の収集',
        text: '調査結果を基に、既存製品の改善案と新デザイン案を含む2種類のプロトタイプを作成。これに対するユーザーからの評価を収集し、デザイン改善の根拠を明確化した。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'その定番プロダクト、UX/UIは次の世代にも選ばれますか？',
  description:
    '外部の視点でUXリサーチを一貫して担い、社内では気づきにくい課題を言語化し、次の一手を明確にします。まずは、現在の課題やお悩みをお聞かせください。',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
